var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UPDATE_DECLARATION_FORM_STATE_REQUEST, updateDeclarationFormstateFailure, updateDeclarationFormstateSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onUpdateDeclarationFormstate = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            APIIN.put(((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.type) === "GST_DECLARATION"
                ? `company/admin/gst/status?tenantId=${action.payload.tenantId}&type=${action.payload.type}&status=${action.payload.status}`
                : `company/admin/gst/status?tenantId=${action.payload.tenantId}&type=${action.payload.type}&status=${action.payload.status}&gstNumber=${action.payload.gstNumber}`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchUpdateDeclarationFormstateWorker(action) {
    try {
        const data = yield call(onUpdateDeclarationFormstate, action);
        yield put(updateDeclarationFormstateSuccess(data));
    }
    catch (error) {
        yield put(updateDeclarationFormstateFailure(error));
    }
}
export function* watchFetchUpdateDeclarationFormstateData() {
    yield takeLatest(UPDATE_DECLARATION_FORM_STATE_REQUEST, fetchUpdateDeclarationFormstateWorker);
}
